import { ApplicationConfig, APP_INITIALIZER, importProvidersFrom } from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideClientHydration } from '@angular/platform-browser';
import { routes } from './app-routing.module';
import { providePsicComponents } from '@pacificspecialtyinsurancecompany/psic-ng-components';
import { DatePipe } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';
import { OktaAuthGuard, OktaAuthModule } from '@okta/okta-angular';
import { authInterceptor } from './auth.interceptor';
import { errorInterceptor } from './error-interceptor';
import { loggingInterceptor } from './logging.interceptor';
import { policyOrchestratorUrlInterceptor } from './policy-orchestrator-url.interceptor';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { policyReducer } from './store/policy/policy.reducer';
import { PolicyEffects } from './store/policy/policy.effects';
import { selectionReducer } from './store/selection/selection.reducer';
import { RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';
import { APP_CONFIG, AppConfig } from 'src/app.config';
import { EMAIL_VALIDATION_TOKEN } from '@pacificspecialtyinsurancecompany/psic-ng-components';
import { EmailService } from './services/email.service';
import { recentPoliciesReducer } from './store/recent-policies/recent-policies.reducer';
import { ConnectService } from './services/amazon-connect.service';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';

export function resolveRecaptchaKey(config: AppConfig): RecaptchaSettings {
    return { siteKey: config.reCaptchaKey };
}

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes),
        provideHttpClient(
            withInterceptors([
                policyOrchestratorUrlInterceptor,
                authInterceptor,
                loggingInterceptor,
                errorInterceptor,
            ])
        ),
        provideClientHydration(),
        providePsicComponents(),
        provideNativeDateAdapter(),
        provideStore({ policy: policyReducer, selection: selectionReducer, recentPolicies: recentPoliciesReducer }),
        provideEffects([PolicyEffects]),
        DatePipe,
        OktaAuthGuard,
        importProvidersFrom(ModalModule, OktaAuthModule),
        {
            provide: RECAPTCHA_SETTINGS,
            useFactory: resolveRecaptchaKey,
            deps: [APP_CONFIG],
        },
        { provide: EMAIL_VALIDATION_TOKEN, useExisting: EmailService },
        {
            provide: APP_INITIALIZER,
            useFactory: (connectService: ConnectService, oktaAuth: OktaAuth) => async () => {
                const isAuthenticated = await oktaAuth.isAuthenticated();
                if (isAuthenticated) {
                    await connectService.init();
                }
            },
            deps: [ConnectService, OKTA_AUTH],
            multi: true,
        },
    ],
};
